<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">色卡新增</h1>
    <div class="top" style="position: relative">
      <el-button
        size="small"
        class="custom-btn"
        style="position: absolute; right: 100px; top: 5px"
        @click="save"
        >保存</el-button
      >
      <div class="form">
        <div class="row">
          <div class="item" style="width: 400px">
            <div class="label" require>门店/仓存</div>
            <el-select
              v-model="md"
              placeholder="请选择门店"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in menlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item" style="width: 500px">
            <div class="label" require>品名</div>
            <el-select
              v-model="pmIdList"
              placeholder="请选择品名"
              style="width: 100%"
              multiple
              collapse-tags
              clearable
              value-key="id"
              filterable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <div class="label" require>数量</div>
            <label>
              <input
                type="text"
                class="cg-input"
                v-model="num"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </label>
          </div>
          <div class="item">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="exp"
                >调入数据</el-button
              >
            </div>
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="add"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column type="index" align="center" width="50" label="序号" />
      <el-table-column align="center" prop="storeName" label="门店/仓存" />
      <el-table-column
        align="center"
        prop="productName"
        label="品名"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="number" label="数量" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label" require>门店</span>
          <el-select
            size="mini"
            class="cg-input"
            filterable
            v-model="upmd"
            placeholder="请选择门店"
            style="padding: 4px 0"
          >
            <el-option
              v-for="item in menlist"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="label" require>品名</span>
          <el-select
            v-model="uppmname"
            placeholder="请选择品名"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in pmlist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">数量</span>
          <label><input type="text" class="cg-input" v-model="upNum" /></label>
        </div>
        <div class="footer">
          <el-button class="custom-btn" size="small" @click="dialogSave"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

// 顶部表单
const md = ref("");
const pmIdList = ref([]); // 品名多选数组
const num = ref("");
const menlist = ref([]);
const pmlist = ref([]);
const list = ref([]);

// 修改弹窗变量
const dialogTableVisible = ref(false);
const upmd = ref("");
const uppmname = ref("");
const upNum = ref("");
const editTempId = ref("");

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardAdd";

// 监听查询条件
watch([md, num, list, pmIdList], () => {
  const searchParams = {
    md: md.value,
    num: num.value,
    list: list.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      md.value = cache.md ?? "";
      num.value = cache.num ?? "";
      list.value = cache.list ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

// 获取门店列表
const mdList = async () => {
  try {
    const res = await proxy.$api.Colorcard.get({});
    if (res.data.code == "200") {
      menlist.value = res.data.data.list.filter(
        (item) => item.name !== "" && item.name !== null
      );
    } else {
      proxy.$message.error("获取门店列表失败");
      menlist.value = [];
    }
  } catch (error) {
    console.error("获取门店列表异常：", error);
    proxy.$message.error("网络错误，获取门店列表失败");
    menlist.value = [];
  }
};

// 获取品名列表
const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      proxy.$message.error("获取产品列表失败");
      pmlist.value = [];
    }
  } catch (error) {
    console.error("获取产品列表异常：", error);
    proxy.$message.error("网络错误，获取产品列表失败");
    pmlist.value = [];
  }
};

const add = () => {
  if (!md.value || pmIdList.value.length === 0 || !num.value) {
    proxy.$message.warning("门店，品名，数量不能为空");
    return;
  }
  const selectedStore = menlist.value.find((item) => item.id === md.value);
  pmIdList.value.forEach((pid) => {
    const selectedItem = pmlist.value.find((item) => item.id === pid);
    if (!selectedItem) return;
    list.value.push({
      id: Math.random() * (200 - 100) + 100,
      storeName: selectedStore.name,
      storeId: md.value,
      productId: pid,
      productName: selectedItem.name,
      number: num.value,
    });
  });
  pmIdList.value = [];
  num.value = "";
};

// 弹窗打开编辑
const up = (row) => {
  dels();
  editTempId.value = row.id;
  upmd.value = row.storeId;
  uppmname.value = row.productId;
  upNum.value = row.number;
  dialogTableVisible.value = true;
};
// 清空弹窗
const dels = () => {
  editTempId.value = "";
  upmd.value = "";
  uppmname.value = "";
  upNum.value = "";
};

const dialogSave = () => {
  const findIndex = list.value.findIndex(
    (item) => item.id === editTempId.value
  );
  if (findIndex === -1) return;
  const storeItem = menlist.value.find((item) => item.id === upmd.value);
  const pmItem = pmlist.value.find((item) => item.id === uppmname.value);
  list.value[findIndex] = {
    ...list.value[findIndex],
    storeId: upmd.value,
    storeName: storeItem?.name || "",
    productId: uppmname.value,
    productName: pmItem?.name || "",
    number: upNum.value,
  };
  dialogTableVisible.value = false;
  proxy.$message.success("修改成功");
};

// 删除临时行
const delUser = (id) => {
  list.value = list.value.filter((item) => item.id !== id);
  proxy.$message.success("删除成功");
};

// 提交全部临时数据到后端
const save = async () => {
  if (list.value.length == 0) {
    proxy.$message.warning("添加数据不能为空");
    return;
  }
  const sendata = {
    colorcardList: list.value.map((item) => {
      const temp = { ...item };
      delete temp.id;
      return temp;
    }),
  };
  console.log(sendata, "参数对不对");
  try {
    const res = await proxy.$api.Colorcard.add(sendata);
    if (res.data.code == "200") {
      proxy.$message.success("新增" + res.data.msg);
      md.value = "";
      pmIdList.value = [];
      num.value = "";
      list.value = [];
    } else {
      proxy.$message.error("新增" + res.data.msg);
    }
  } catch (error) {
    console.error("新增异常：", error);
    proxy.$message.error("网络错误，新增失败");
  }
};

//调入数据，占位
const exp = () => {};

onMounted(() => {
  mdList();
  pmList();
  loadSearchCache();
});
</script>

<style lang="scss" scoped>
@import "./colorcardAdd.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
</style>
